import InputHelp from './InputHelp';
import InputLabel from './InputLabel';
import InputText from './InputText';
import InputView from './InputView';



export default {
  Help: InputHelp,
  Label: InputLabel,
  View: InputView,
  Text: InputText,
};
